import { useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import _ from "underscore"
import { callautopopulate } from "../../../services/callautopop"
import { ToastContext } from "../../../context/ToastContext"
import { dateConvert } from "../../../utils/Helper"
import { DateObject } from "react-multi-date-picker"

export const useDeviceDashBoard = () => {
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [deviceData, setDeviceData] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [users, setUsers] = useState([]);
    const tagRef = useRef();
    const [deviceOpts, setDeviceOpts] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [columnDefs] = useState([
        {
            field: "device_name",
            headerName: "Device Name",
            width: 100,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "device_sku_id",
            headerName: "SKU",
            width: 100,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "assigned_to_user_display_name",
            headerName: "Assigned to",
            width: 150,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "issued_datetime",
            headerName: "Assigned Date",
            width: 170,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value ? dateConvert(params?.value, "date-time-months") : ""}</div>
                )
            }
        },
        {
            field: "received_datetime",
            headerName: "Returned Date",
            width: 170,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value ? dateConvert(params?.value, "date-time-months") : ""}</div>
                )
            }
        },
    ]);
    const [historyPopup, setHistoryPopup] = useState(false);
    const [popupFilters, setPopupFilters] = useState({ device: [], users: [], hoveredRange: [new DateObject(), new DateObject()] });
    const [loader, setLoader] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [userData, setUserData] = useState(null)

    useEffect(() => {
        callautopopulate("users", "user_info").then((res) => {
            setUsers(res?.users?.map((user) => ({
                label: user.user_display_name,
                value: user.user_code,
            })).sort((a, b) => a.label?.localeCompare(b.label)));
            setUserData(res?.user_info[0])
            if (!(res?.user_info[0]?.user_category_key === 'service-desk' || res?.user_info[0]?.user_category_key === 'it-support')) {
                setSelectedData((prev) => ({ ...prev, user: res?.user_info[0]?.user_code }))
            }
        })
        getDeviceData()
    }, []);


    useEffect(() => {
        // select current month as default in popup
        if (!historyPopup) {
            setPopupFilters((prev) => ({ ...prev, hoveredRange: [new DateObject(), new DateObject()] }));
        }
    }, [historyPopup])

    useEffect(() => {
        historyPopup && ((popupFilters?.hoveredRange?.[0] && popupFilters?.hoveredRange?.[1]) || (!popupFilters?.hoveredRange?.[0] && !popupFilters?.hoveredRange?.[1])) && getDeviceHistory();
    }, [popupFilters?.hoveredRange, historyPopup])

    const getDeviceData = async () => {
        try {
            const res = await services?.getInvokeRemote("GET", Urls("GETDEVICEINFOCARDVIEW"))
            const data = res?.body?.data?.device_card_data
            if (res?.status === 200 && data) {
                const available = _.filter(data, { is_available: 1 })
                const unavailable = _.filter(data, { is_available: 0 })
                setDeviceData({ available, unavailable })
                setDeviceOpts(data?.map((user) => ({
                    label: `${user?.device_name} ( ${user?.device_sku_id} )`,
                    value: user?.device_id,
                })).sort((a, b) => a.label?.localeCompare(b.label)));
            }
        } catch (error) {
            console.error(error, "error");
        }
    }

    const handleAssignreceive = async () => {
        try {
            if (selectedData?.type === "I" && !selectedData?.user) {
                showInfo("info", "Please select a user.");
                return
            }
            const payload = {
                "request_id": selectedData?.data?.request_id || 0,
                "device_id": selectedData?.data?.device_id,
                "assigned_to": selectedData?.user || 0,
                "action_type": selectedData?.type
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTDEVICEASSIGNRECEIVE"), payload);
            if (res?.status === 200 && !res?.body?.data?.error_status) {
                showSuccess("Success", res.body.message);
                getDeviceData();
            } else {
                showError("Error", res.body.errorMessage);
            }
            setShowPopup(false)
        } catch (error) {
            console.error("Error getting device: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const getDeviceHistory = async (emptyDevice, emptyUsers) => {
        try {
            setLoader(true);
            const payload = {
                device_ids: emptyDevice ? "" : popupFilters?.device?.toString() || "",
                from_date: dateConvert(popupFilters?.hoveredRange?.[0]?.toDate(), "iso-string") || "",
                to_date: dateConvert(popupFilters?.hoveredRange?.[1]?.toDate(), "iso-string") || "",
                requested_user_codes: emptyUsers ? "" : popupFilters?.users?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("GETDEVICEINFOREQUESTLIST"), payload);
            if (res) {
                let data = res?.body?.data?.device_request_list;
                data = data.sort((a, b) => { return new Date(b?.issued_datetime) - new Date(a?.issued_datetime) });
                setRowData(data);
                setLoader(false);
            }
        } catch (error) {
            console.error("Error getting device history: ", error);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        deviceData, handleAssignreceive, showPopup, setShowPopup, selectedData, setSelectedData, users, tagRef, historyPopup, setHistoryPopup, getDeviceHistory, popupFilters, setPopupFilters, deviceOpts, rowData, columnDefs, loader, isChange, setIsChange, userData
    }), [deviceData, handleAssignreceive, showPopup, setShowPopup, selectedData, setSelectedData, users, tagRef, historyPopup, setHistoryPopup, getDeviceHistory, popupFilters, setPopupFilters, deviceOpts, rowData, columnDefs, loader, isChange, setIsChange, userData])
}